const numberGroup = {
  9000: "nineThousand",
  8000: "eightThousand",
  7000: "sevenThousand",
  6000: "sixThousand",
  5000: "fiveThousand",
  4000: "fourThousand",
  3000: "threeThousand",
  2000: "twoThousand",
  1000: "oneThousand",
  900: "nineHundred",
  800: "eightHundred",
  700: "sevenHundred",
  600: "sixHundred",
  500: "fiveHundred",
  400: "fourHundred",
  300: "threeHundred",
  200: "twoHundred",
  100: "oneHundred",
  90: "ninety",
  80: "eighty",
  70: "seventy",
  60: "sixty",
  50: "fifty",
  40: "forty",
  30: "thirty",
  20: "twenty",
  10: "ten",
  9: "nine",
  8: "eight",
  7: "seven",
  6: "six",
  5: "five",
  4: "four",
  3: "three",
  2: "two",
  1: "one",
};

export default numberGroup;
